<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title
        :title="$t('message.extrawork.title', { value: 'default' })"
      ></portal-title>
      <portal-breadcumb></portal-breadcumb>
      <div class="content">
        <v-row justify="center">
          <v-row class="mb-5 mr-3">
                  <v-col offset-md="4"
                    ><v-text-field
                      v-model="searchQuote"
                      append-icon="mdi-magnify"
                      :label="$t('message.search', { value: 'default' })"
                      single-line
                      hide-details
                    ></v-text-field
                  ></v-col>
                </v-row>
          <v-expansion-panels inset v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header color="#00475A"
                >{{ $t("message.extrawork.tovalidate", { value: "default" }) }}
                <template v-slot:actions>
                  <v-icon color="#FFFFFF"> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headersQuotesToValidateTable"
                  :items="quotesToValidate"
                  :search="searchQuote"
                  :loading="loading"
                  :loading-text="
                    $t('message.loadingText', { value: 'default' })
                  "
                >
                  <template v-slot:[`item.action`]="{ item }">
                    <div class="detail">
                      <v-btn color="#6E85A2" dark @click="showValidation(item.wonum)">
                      {{ $t("message.extrawork.confirm", { value: "default" }) }}
                    </v-btn>
                    <v-btn color="#6E85A2" dark @click="showReject(item.wonum)">
                      {{ $t("message.extrawork.reject", { value: "default" }) }}
                    </v-btn>
                    </div>
                  </template>
                  <template v-slot:[`item.ldescription`]="{ item }">
                    {{ filterHtml(item.ldescription) }}
                  </template>
                  <template v-slot:[`item.wonum`]="{ item }">
                    <a @click="showDetails(quotesToValidate, item.wonum)" class="quote-link">{{ item.wonum }}</a>
                  </template>
                  <template v-slot:[`item.assetnum`]="{ item }">
                    <a @click="infoloc(item.assetnum)" class="quote-link">{{ item.assetnum }}</a>
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    {{ formatPrice(item.price) }}
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header color="#00475A"
                >{{ $t("message.extrawork.validated", { value: "default" }) }}
                <template v-slot:actions>
                  <v-icon color="#FFFFFF"> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>

                <v-data-table
                  :headers="headersValidatedQuotes"
                  :items="validatedQuotes"
                  :search="searchQuote"
                  light
                >
                  <template v-slot:[`item.actstart`]="{ item }">
                    {{ formatedDate(item.actstart) }}
                  </template>
                  <template v-slot:[`item.wonum`]="{ item }">
                    <a @click="showDetails(validatedQuotes, item.wonum)" class="quote-link">{{ item.wonum }}</a>
                  </template>
                  <template v-slot:[`item.ldescription`]="{ item }">
                    {{ filterHtml(item.ldescription) }}
                  </template>
                  <template v-slot:[`item.assetnum`]="{ item }">
                    <a @click="infoloc(item.assetnum)" class="quote-link">{{ item.assetnum }}</a>
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    {{ formatPrice(item.price) }}
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    {{ getStatus(item.status) }}
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- rejected quotes -->
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header color="#00475A"
                >{{ $t("message.extrawork.rejected", { value: "default" }) }}
                <template v-slot:actions>
                  <v-icon color="#FFFFFF"> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>

                <v-data-table
                  :headers="headersRejectedQuotes"
                  :items="rejectedQuotes"
                  :search="searchQuote"
                  light
                >
                  <template v-slot:[`item.wonum`]="{ item }">
                    <a @click="showDetails(rejectedQuotes, item.wonum)" class="quote-link">{{ item.wonum }}</a>
                  </template>
                  <template v-slot:[`item.ldescription`]="{ item }">
                    {{ filterHtml(item.ldescription) }}
                  </template>
                  <template v-slot:[`item.assetnum`]="{ item }">
                    <a @click="infoloc(item.assetnum)" class="quote-link">{{ item.assetnum }}</a>
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    {{ formatPrice(item.price) }}
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </div>

      <v-dialog
      v-model="showDetail"
      width="800"
      overlay-color="#fff"
      overlay-opacity="0.5"
    >
      <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
        <v-system-bar height="30" color="#fff" class="px-0 mb-3">
          <span></span>
          <v-spacer></v-spacer>
          <v-icon size="32" class="pt-5" @click="showDetail = false"
            >mdi-close</v-icon
          >
        </v-system-bar>

        <QuoteInfo
          :doclinks="doclinks"
          :quote="quote"
        ></QuoteInfo>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showValidationPopup"
      width="600"
      overlay-color="#fff"
      overlay-opacity="0.5"
    >
      <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
        <v-system-bar height="30" color="#fff" class="px-0 mb-3">
          <span></span>
          <v-spacer></v-spacer>
          <v-icon size="32" class="pt-5" @click="showValidationPopup = false"
            >mdi-close</v-icon
          >
        </v-system-bar>

        <v-card outlined elevation="0" style="border: none">
          <v-card-title>
            <h4 class="message">{{ $t("message.extrawork.messageconfirm", { value: "default" }) }}
              <v-text-field class="input-valid" outlined dense color="#00475A" v-model="poNum" placeholder="PO number"></v-text-field></h4> 
          </v-card-title>
          <v-card-text class="pt-1">
            <v-row class="px-1 mb-1">
              
              <div class="valid-popup-buttons">
                <v-btn color="#6E85A2" dark @click="hideValidation()">
                  {{ $t("message.button.cancel", { value: "default" }) }}
                </v-btn>
                <v-btn color="#6E85A2" dark @click="validate()">
                  {{ $t("message.button.submit", { value: "default" }) }}
                </v-btn>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showRejectPopup"
      width="650"
      overlay-color="#fff"
      overlay-opacity="0.5"
    >
      <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
        <v-system-bar height="30" color="#fff" class="px-0 mb-3">
          <span></span>
          <v-spacer></v-spacer>
          <v-icon size="32" class="pt-5" @click="showRejectPopup = false"
            >mdi-close</v-icon
          >
        </v-system-bar>

        <v-card outlined elevation="0" style="border: none">
          <v-card-title>
            <h4 class="message">{{ $t("message.extrawork.whyreject", { value: "default" }) }} {{ quote.wonum }} : 
              <v-textarea ref="reason" :rules="reasonRules" outlined dense color="#00475A" v-model="reason" placeholder="rejection reason" required></v-textarea></h4> 
          </v-card-title>
          <v-card-text class="pt-1">
            <v-row class="px-1 mb-1">
              
              <div class="valid-popup-buttons">
                <v-btn color="#6E85A2" dark @click="hideReject()">
                  {{ $t("message.extrawork.cancel", { value: "default" }) }}
                </v-btn>
                <v-btn color="#6E85A2" dark @click="reject()">
                  {{ $t("message.extrawork.confirm", { value: "default" }) }}
                </v-btn>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import { mapGetters } from "vuex";
import { formatMagicDate } from "@/shared/DateHelper";
import MaximoService from "@/services/MaximoService";
import QuoteService from "@/services/QuoteService";
import QuoteInfo from "../components/QuoteInfo.vue";
import { getProfile } from "@/shared/UserProfile";

export default {
  methods: {

    formatedDate(date) {
      if (date == "") {
        return "";
      }

      if (date == undefined) {
        return "";
      }

      if (date == null) {
        return "";
      }
      return formatMagicDate(date);
    },

    getStatus(status){
      if(status == "Accepted") {
        return this.$t("message.extrawork.statusvalidated", { value: "default" });
      } else if(status == "Billed") {
        return this.$t("message.extrawork.statusbilled", { value: "default" });
      } else if(status == "Rejected") {
        return this.$t("message.extrawork.quoterejected", { value: "default" });
      } else if(status == "Waiting for validation") {
        return this.$t("message.extrawork.tovalidate", { value: "default" });
      } else return status;
    },

    formatPrice(price){
      return new Intl.NumberFormat(this.$i18n.locale).format(parseFloat(price).toFixed(2));
    },
    
    infoloc(assetnum) {
      window.location = document.location.origin + "/infoloc/" + assetnum;
    },

    async showDetails(quotes, wonum) {
      this.quote = quotes.find((e) => e.wonum == wonum);
       await MaximoService.getQuotationDoclinks(this.quote.workorderid)
        .then((response) => {
          this.doclinks = response.data;
          this.showDoclink = true;
        })
        .catch(() => {
          this.doclinks = [];
          this.showDoclink = false;
        });
      this.showDetail = true;
    },

    async showValidation(wonum) {
      this.quote = this.quotesToValidate.find((e) => e.wonum == wonum);
      this.showValidationPopup = true;
    },
    async showReject(wonum) {
      this.quote = this.quotesToValidate.find((e) => e.wonum == wonum);
      this.showRejectPopup = true;
    },

    async hideReject() {
      this.showRejectPopup = false;
      this.reason = null;
      this.$refs.reason.reset();
    },

    async hideValidation() {
      this.showValidationPopup = false;
      this.poNum = null;
      
    },

    async validate() {
      this.quote.customer = this.getterCurrentClient;
      this.quote.customerPo = this.poNum;
      this.quote.userName = this.getterAuthData.name;
      this.quote.userGivenname = this.getterAuthData.givenname;
      QuoteService.validateQuote(this.quote).then(() => {
          this.loadQuotes();
        }).catch(() => {
          this.loadQuotes();
        });
        this.showValidationPopup = false;
        this.poNum = null;
    },

    async reject() {
      if(this.reason && this.reason.length>=5){
        QuoteService.rejectQuote(this.quote.worklogid, this.reason).then(() => {
          this.loadQuotes();
        });
        this.showRejectPopup = false;
        this.reason = null;
      }
      
    },


    async loadQuotes() {
      this.getQuotesToValidate();
      this.getValidatedQuotes();
      this.getRejectedQuotes();
    },

    async getQuotesToValidate() {
      this.loading = true;
      await QuoteService.loadQuotesToValidate(this.getterCurrentClient).then((response) => {
          this.quotesToValidate = response.data;
        })
        .catch(() => {
          this.quotesToValidate = [];
        });

      this.loading = false;
    },

    async getValidatedQuotes() {
      this.loading = true;
      await QuoteService.loadValidatedQuotes(this.getterCurrentClient).then((response) => {
          this.validatedQuotes = response.data;
        })
        .catch(() => {
          this.validatedQuotes = [];
        });

      this.loading = false;
    },

    async getRejectedQuotes() {
      this.loading = true;
      await QuoteService.loadRejectedQuotes(this.getterCurrentClient).then((response) => {
          this.rejectedQuotes = response.data;
        })
        .catch(() => {
          this.rejectedQuotes = [];
        });

      this.loading = false;
    },

    filterHtml(value) {
      if(value){
        let regex = /(<([^>]+)>)/ig;
        return value.replace(regex, "");
      }
    }
  },

  mounted() {
    this.loadQuotes();
    this.profile = getProfile(this.getterAuthData.profils,this.getterFunctionnalities);
  },

  data() {
    return {
      panel: 0,
      quotesToValidate: [],
      validatedQuotes: [],
      rejectedQuotes: [],
      searchQuote: "",
      searchcm: "",
      doclinks: [],
      loading: true,
      quote: {},
      showDoclink: false,
      showDetail: false,
      showValidationPopup: false,
      showRejectPopup: false,
      profile : {
            extrawork: false,
            validateQuote: false,
            rejectQuote: false,
          },
      poNum: "",
      reason: "",
      reasonRules: [
        (v) => !!v || this.$t("message.extrawork.rejectcomment", { value: "default" }),
        (v) =>
          (v && v.length >= 5) ||
          this.$t("message.extrawork.rejectcomment", { value: "default" }),
      ],
            
    };
  },
  name: "QuotePage",
  title: "Quotes",

  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    QuoteInfo,
  },
  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterAuthData: "getAuthData",
      getterFunctionnalities: "getFunctionnalities",
    }),

    ...mapGetters("carpet", {
      getterHistories: "getHistories",
    }),


    headersQuotesToValidateTable() {
      const headers = [
        {
          text: this.$t("message.pageKm.loco", { value: "default" }),
          value: "assetnum",
          sortable: true,
        },

        {
          text: this.$t("message.extrawork.quotenum", { value: "default" }),
          value: "wonum",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.quotetitle", { value: "default" }),
          value: "description",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.quoteprice", { value: "default" }),
          value: "price",
          sortable: true,
        },
      ];
      if(this.profile?.extrawork && this.profile?.validateQuote && this.profile?.rejectQuote){
        headers.push({
          text: "",
          value: "action",
          sortable: false,
          show: false
        })
      }

      return headers;
    },

    headersValidatedQuotes() {
      return [
        {
          text: this.$t("message.pageKm.loco", { value: "default" }),
          value: "assetnum",
          sortable: true,
        },

        {
          text: this.$t("message.extrawork.quotenum", { value: "default" }),
          value: "wonum",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.quotetitle", { value: "default" }),
          value: "description",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.quotestatus", { value: "default" }),
          value: "status",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.realisationdate", { value: "default" }),
          value: "actstart",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.customerpo", { value: "default" }),
          value: "po",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.quoteprice", { value: "default" }),
          value: "price",
          sortable: true,
        },
      ];
    },

    headersRejectedQuotes() {
      return [
        {
          text: this.$t("message.pageKm.loco", { value: "default" }),
          value: "assetnum",
          sortable: true,
        },

        {
          text: this.$t("message.extrawork.quotenum", { value: "default" }),
          value: "wonum",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.quotetitle", { value: "default" }),
          value: "description",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.quoteprice", { value: "default" }),
          value: "price",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.comment", { value: "default" }),
          value: "remark",
          sortable: true,
        },
      ];
    },

  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  color: #fff;
}

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 16px;
}

.value {
  font-size: 16px;
}

.detail {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-evenly;
}

.detail button{
  height: 25px !important;
}

.quote-link {
  color: rgba(0, 0, 0, 0.87);
}

:deep(.input-valid) {
  width: 50%;
}

.valid-popup-buttons {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}

.message {
  word-break: normal;
  flex-basis: 100%;
}
</style>
